exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.skeleton[data-v-077a67bb] {\n  margin: 0 !important;\n  padding: 0 !important;\n  border-color: rgb(217, 217, 217);\n  border-radius: 4px;\n  height: 30px;\n}\n", ""]);

// exports
